import { BuilderConfig, FontAwesomeIconKey } from './builderConfigs'
import { useSelector } from '../..'
import { Spin } from 'antd'

const MAX_TITLE_LENGTH = 100
const MAX_DESC_LENGTH = 500

const icon: FontAwesomeIconKey = 'fa-file-pdf-o'

type pdfObject = {
  s3Key: string
  error: string | undefined
  loading: boolean | undefined
}

export const SolutionBuilderConfig: BuilderConfig<'solution'> = {
  key: 'solution',
  builderHomeData: {
    type: 'solution',
    description: (
      <p>
        The Solution builder assembles images and text into an asset which can
        be shared or downloaded as a PDF.
      </p>
    ),
    enabled: true,
    icon: 'file-pdf-o',
    route: '/builders/solution',
    title: 'Solution',
  },
  previewLabels: {
    title: 'Solution',
    description:
      'The Solution builder assembles images and text into an asset which can be assembled via a ' +
      'template and viewed/shared/downloaded on web or mobile as a PDF.',
  },
  crumbTrail: {
    linkTo: '/builders/home',
    crumbText: 'Solution',
    crumbIcon: `fa ${icon}`,
  },
  fieldValidators: {
    title: {
      validateTrigger: 'onBlur',
      rules: [
        { required: true, message: 'Title is required' },
        {
          max: MAX_TITLE_LENGTH,
          message: `Title has a maximum character limit of ${MAX_TITLE_LENGTH}`,
        },
      ],
    },
    description: {
      validateTrigger: 'onBlur',
      rules: [
        {
          max: MAX_DESC_LENGTH,
          message:
            `Description has a maximum character limit of ` +
            `${MAX_DESC_LENGTH}`,
        },
      ],
    },
  },
  formLabels: {},
  icon,
  screenHandlers: {
    createScreen: {
      next: (saveToDb) => saveToDb(),
    },
    metaScreen: {
      next: (saveToDb) => saveToDb(),
    },
  },
  assetSerializer: (data) => {
    const { builderData, user } = data
    const assetMetaData = {
      id: builderData.id,
      asset_type: SolutionBuilderConfig.key,
      owner: user.id,
      title: builderData.title,
      description: builderData.description,
      tags: builderData.tags,
      icon,
      color: '#22075e',
      preview: null,
    }
    return {
      assetMetaData,
      assetData: { ...builderData, image: builderData.leadImage },
      ContentType: 'application/json',
      assetDataSerialized: JSON.stringify(builderData),
    }
  },
  Content: () => {
    const baseUrl = useSelector((state: any) => state.config.appConfig.baseUrl)
    const pdf = useSelector(
      (state: any) => state.builders[SolutionBuilderConfig.key].pdf,
    ) as pdfObject

    if (!pdf) {
      return (
        <div className="solution__pdf-info">
          <span>Start by adding a Title, then uploading Solution Data.</span>
        </div>
      )
    }

    if (pdf.error) {
      console.error('PDF Generation Error: ' + pdf.error)
      return (
        <div className="solution__pdf-info">
          <span className="error">PDF Generation error: {pdf.error}</span>
        </div>
      )
    }

    if (pdf.loading) {
      return (
        <div className="solution__pdf-spinner">
          <Spin />
        </div>
      )
    }

    if (!pdf.s3Key) {
      console.error('PDF Generation Error: ' + pdf.error)
      return <div className="solution__pdf-info"></div>
    }

    let url = `${baseUrl}/${pdf.s3Key}#toolbar=0&view=Fit`

    return (
      <div className="assetdetail__preview">
        <object
          className="builders__preview-pdf"
          key={'preview'}
          data={url}
          type="application/pdf"
          width={'100%'}
          height={'100%'}
        >
          <param name="zoom" value="scale" />
          <param name="view" value="FitV" />
          <embed src={url} type="application/pdf"></embed>
        </object>
      </div>
    )
  },
}
